import { Alert, HStack, Link, Text, VStack } from 'native-base';
import { useRouter } from '~/hooks/useRouter';

export type AlertMessageProps = {
  helpLink?: string;
  title?: string;
  description?: string;
  status?: 'info' | 'warning' | 'success' | 'error';
  isExternalLink?: boolean;
};

export const AlertMessage = ({
  helpLink = '',
  title = '',
  description = '',
  status = 'info',
  isExternalLink = false,
}: AlertMessageProps) => {
  const { goToRoute } = useRouter();

  const handleExternalLink = () => {
    if (isExternalLink) {
      window.open(helpLink, '_blank');
    } else {
      goToRoute(helpLink);
    }
  };

  return (
    <Alert status={status} backgroundColor={'info.100'} mt={2}>
      <HStack alignItems={'center'} w="full" space={2}>
        <Alert.Icon size={6} variant={'outline'} />
        <VStack>
          <Text fontSize={'sm'} fontWeight={500} color={'gray.800'}>
            {title}
          </Text>
          {helpLink ? (
            <Text fontSize={14} fontWeight={500} letterSpacing="150%">
              <Link isExternal onPress={handleExternalLink}>
                {description}
              </Link>
            </Text>
          ) : (
            <Text
              fontSize={14}
              fontWeight={400}
              color={'gray.800'}
              letterSpacing="150%"
            >
              {description}
            </Text>
          )}
        </VStack>
      </HStack>
    </Alert>
  );
};
